"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectSuggest = exports.AsyncComboBox = exports.InsertingComboBox = exports.ComboBox = exports.choices_to_suggestions = exports.emptySuggestion = void 0;
var React = require("react");
var Autosuggest = require("react-autosuggest");
var mobx_react_1 = require("mobx-react");
var dialog_1 = require("../dialog");
var buttons_1 = require("../buttons");
var lodash_1 = require("lodash");
var config_1 = require("../../config");
exports.emptySuggestion = {
    label: '(no selection)',
    suggestionLabel: '(no selection)',
    value: ''
};
var choices_to_suggestions = function (choices) {
    return [exports.emptySuggestion].concat(choices.map(function (choice) {
        return {
            label: choice.display_name,
            suggestionLabel: choice.display_name,
            value: choice.value
        };
    }));
};
exports.choices_to_suggestions = choices_to_suggestions;
var BaseComboBox = (function (_super) {
    __extends(BaseComboBox, _super);
    function BaseComboBox(props) {
        var _this = _super.call(this, props) || this;
        _this.onSuggestionsClearRequested = function () {
            _this.setState({
                suggestions: [],
                hasChanged: false
            });
        };
        _this.state = _this.getInitialState();
        return _this;
    }
    BaseComboBox.prototype.getInitialState = function () {
        return {
            inputValue: this.getInputValueFromValue(this.props),
            suggestions: [],
            hasChanged: false,
        };
    };
    BaseComboBox.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.options != this.props.options) {
            this.setState({
                inputValue: this.getInputValueFromValue(nextProps)
            });
        }
    };
    BaseComboBox.prototype.getInputValueFromValue = function (props) {
        if (props.value == null) {
            return '';
        }
        var suggestion = props.options.filter(function (suggestion) {
            return suggestion.value == props.value;
        })[0];
        if (suggestion !== undefined) {
            return suggestion.suggestionLabel || suggestion.label;
        }
        return "";
    };
    BaseComboBox.prototype.getSuggestions = function (value) {
        var props = this.props;
        var inputValue = value.trim().toLowerCase();
        var inputLength = inputValue.length;
        return inputLength === 0 || !this.state.hasChanged
            ? props.options.slice(0)
            : props.options.filter(function (suggestion) {
                return suggestion.suggestionLabel.toLowerCase().indexOf(inputValue) >= 0;
            });
    };
    BaseComboBox.prototype.shouldRenderSuggestions = function () {
        return true;
    };
    BaseComboBox.prototype.getSuggestionValue = function (suggestion) {
        return suggestion.label;
    };
    BaseComboBox.prototype.renderSuggestion = function (suggestion) {
        return React.createElement("div", null, suggestion.suggestionLabel || suggestion.label);
    };
    BaseComboBox.prototype.onTextChange = function (event, params) {
        this.setState({
            inputValue: params.newValue,
            hasChanged: true,
        });
        if (params.newValue == '') {
            this.props.onChange(null);
        }
    };
    ;
    BaseComboBox.prototype.onBlur = function () {
        this.setState({
            hasChanged: false,
        });
        if (this.props.onBlur)
            this.props.onBlur();
    };
    ;
    BaseComboBox.prototype.onSuggestionsFetchRequested = function (data) {
        this.setState({
            suggestions: this.getSuggestions(data.value)
        });
    };
    ;
    BaseComboBox.prototype.onSuggestionSelected = function (event, data) {
        this.props.onChange(data.suggestion.value);
        this.setState({
            hasChanged: false
        });
    };
    BaseComboBox.prototype.componentDidMount = function () {
        if (this._input && this.props.autofocus === true)
            this._input.focus();
    };
    BaseComboBox.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var value = this.state.inputValue;
        var suggestions = this.state.suggestions;
        var inputProps = {
            placeholder: props.placeholder || null,
            value: value,
            onChange: this.onTextChange.bind(this),
            onBlur: this.onBlur.bind(this),
            className: "form-control",
            id: props.id || null,
        };
        if (props.className) {
            inputProps['className'] = props.className;
        }
        return (React.createElement("div", { style: { position: 'relative' } },
            React.createElement(Autosuggest, { suggestions: suggestions, ref: function (me) {
                    if (me && !_this._input)
                        _this._input = me.input;
                }, focusInputOnSuggestionClick: this.props.focusInputOnSuggestionClick, onSuggestionsFetchRequested: this.onSuggestionsFetchRequested.bind(this), onSuggestionsClearRequested: this.onSuggestionsClearRequested, getSuggestionValue: this.getSuggestionValue, renderSuggestion: this.renderSuggestion, shouldRenderSuggestions: this.shouldRenderSuggestions, onSuggestionSelected: this.onSuggestionSelected.bind(this), inputProps: inputProps })));
    };
    return BaseComboBox;
}(React.Component));
var ComboBox = (function (_super) {
    __extends(ComboBox, _super);
    function ComboBox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ComboBox;
}(BaseComboBox));
exports.ComboBox = ComboBox;
var InsertingComboBox = (function (_super) {
    __extends(InsertingComboBox, _super);
    function InsertingComboBox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InsertingComboBox.prototype.getInitialState = function () {
        var state = _super.prototype.getInitialState.call(this);
        state.waitingForConfirmation = false;
        state.selectedSuggestion = null;
        return state;
    };
    InsertingComboBox.prototype.getSuggestions = function (value) {
        var suggestions = _super.prototype.getSuggestions.call(this, value);
        var inputValue = value.trim();
        if (!this.props.createOption === false) {
            suggestions.splice(0, 0, {
                suggestionLabel: "Create new entry for ".concat(inputValue),
                label: inputValue,
                value: inputValue,
                isSpecial: true,
            });
        }
        return suggestions;
    };
    InsertingComboBox.prototype.onSuggestionSelected = function (event, data) {
        var selected = data.suggestion;
        if (selected && selected.isSpecial) {
            this.setState({ waitingForConfirmation: true });
        }
        else {
            _super.prototype.onSuggestionSelected.call(this, event, data);
        }
    };
    InsertingComboBox.prototype.onReceivingConfirmation = function (event, confirmed) {
        if (confirmed) {
            this.props.insertInstruction(this.state.inputValue);
            this.setState({
                waitingForConfirmation: false,
            });
        }
        else {
            this.setState({
                waitingForConfirmation: false,
            });
        }
    };
    InsertingComboBox.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var state = this.state;
        return (React.createElement("div", null,
            _super.prototype.render.call(this),
            React.createElement(dialog_1.Dialog, { isOpen: state.waitingForConfirmation, contentLabel: gettext("Confirmation"), forcedWidth: "300px" },
                React.createElement("p", null, props.confirmationText ? props.confirmationText(state.inputValue) :
                    gettext("Are you sure?")),
                React.createElement(buttons_1.PrimaryButton, { onClick: function (e) { _this.onReceivingConfirmation(e, true); } }, "Yes"),
                React.createElement(buttons_1.Button, { onClick: function (e) { _this.onReceivingConfirmation(e, false); } }, "No"))));
    };
    InsertingComboBox = __decorate([
        mobx_react_1.observer
    ], InsertingComboBox);
    return InsertingComboBox;
}(BaseComboBox));
exports.InsertingComboBox = InsertingComboBox;
var AsyncComboBox = (function (_super) {
    __extends(AsyncComboBox, _super);
    function AsyncComboBox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.debouncedLoadSuggestions = (0, lodash_1.debounce)(_this.loadSuggestions, config_1.DEBOUNCE_DELAY);
        return _this;
    }
    AsyncComboBox.prototype.getInputValueFromValue = function (props) {
        if (props.value == null)
            return "";
        var suggestions = this.state ?
            this.state.suggestions :
            props.options || [];
        var suggestion = suggestions.filter(function (suggestion) {
            return suggestion.value == props.value;
        })[0];
        return suggestion ? suggestion.suggestionLabel || suggestion.label : "";
    };
    AsyncComboBox.prototype.loadSuggestions = function (value) {
        var _this = this;
        this.props.fetchSuggestions(value).then(function (suggestions) {
            _this.toggleLoading(false);
            _this.setState({
                suggestions: suggestions || [],
            });
        }, function (e) { return console.error(e); });
    };
    AsyncComboBox.prototype.onSuggestionsFetchRequested = function (data) {
        this.toggleLoading(true);
        this.debouncedLoadSuggestions(data.value);
    };
    AsyncComboBox.prototype.toggleLoading = function (addSpinner) {
        if (addSpinner === true)
            $(this._input).addClass('InputText--loading');
        else
            $(this._input).removeClass('InputText--loading');
    };
    AsyncComboBox.prototype.onTextChange = function (event, params) {
        this.setState({
            inputValue: params.newValue,
            hasChanged: true,
        });
    };
    ;
    return AsyncComboBox;
}(BaseComboBox));
exports.AsyncComboBox = AsyncComboBox;
var ObjectSuggest = (function (_super) {
    __extends(ObjectSuggest, _super);
    function ObjectSuggest(props) {
        var _this = _super.call(this, props) || this;
        _this.onChange = function (value) {
            _this.setState({
                currentSelected: value,
            });
            if (_this.props.onChange)
                _this.props.onChange(value);
        };
        _this.state = {
            currentSelected: props.selected ? props.selected.toString() : null,
        };
        return _this;
    }
    ObjectSuggest.prototype.generateSuggestions = function () {
        var _this = this;
        return this.props.objects.map(function (obj) {
            if (_this.props.objectToSuggestion) {
                return _this.props.objectToSuggestion(obj);
            }
            return {
                value: obj.toString(),
                label: obj.toString(),
                suggestionLabel: obj.toString(),
            };
        });
    };
    ObjectSuggest.prototype.componentWillReceiveProps = function (nextProps, nextContext) {
        if (nextProps.selected !== this.props.selected) {
            this.setState({
                currentSelected: nextProps.selected !== null ? nextProps.selected.toString() : null
            });
        }
    };
    ObjectSuggest.prototype.render = function () {
        var options = this.generateSuggestions();
        return (React.createElement(ComboBox, { options: options, value: this.state.currentSelected, placeholder: this.props.defaultOptionText, onChange: this.onChange, onBlur: this.props.onBlur, autofocus: this.props.autofocus, focusInputOnSuggestionClick: this.props.focusInputOnSuggestionClick, id: this.props.id }));
    };
    return ObjectSuggest;
}(React.Component));
exports.ObjectSuggest = ObjectSuggest;
